<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      stroke="#6b7280"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M6 8l4 4 4-4"
    />
  </svg>
</template>
